import React, { PureComponent } from 'react';
import { Container, Col, Row, Modal, Button, Form } from 'react-bootstrap';
import Select from 'react-select'

const SYMBOLS = {
    "descriptive_symbols": {
        BW: "Black & White TV",
        C: "Color TV",
        CP: "Carrier Packed",
        PBO: "Packed by Owner",
        CD: "Carrier Disassembled",
        SW: "Stretch Wrapped",
        DBO: "Disassembled by Owner",
        PB: "Professional Books",
        PE: "Professional Equipment",
        PP: "Professional Papers",
        MCU: "Mechanical Condition Unknown",
        CU: "Contents & Condition Unknown"
    },
    "exception_symbols": {
        BE: "Bent",
        BR: "Broken",
        BU: "Burned",
        CH: "Chipped",
        D: "Dented",
        F: "Faded",
        G: "Gouged",
        L: "Loose",
        M: "Marred",
        MI: "Mildew",
        MO: "Motheaten",
        P: "Peeling",
        R: "Rubbed",
        RU: "Rusted",
        SC: "Scratched",
        SH: "Short",
        SO: "Soiled",
        ST: "Stained",
        S: "Stretched",
        T: "Torn",
        W: "Badly Worn",
        Z: "Cracked"

    },
    "location_symbols": {
        1: "Arm",
        2: "Bottom",
        3: "Corner",
        4: "Front",
        5: "Left",
        6: "Leg",
        7: "Rear",
        8: "Right",
        9: "Side",
        10: "Top",
        11: "Veneer",
        12: "Edg",
        13: "Center",
        14: "Inside",
        15: "Seat",
        16: "Drawer",
        17: "Door",
        18: "Shelf",
        19: "Hardware",

    }
}
const initProps = {
    article: "",
    descriptive_symbols: [],
    exception_symbols: [],
    location_symbols: [],
}
class AddNewArticles extends PureComponent {
    constructor(props) {
        super(props)
        this.state = {
            ...initProps,
            showAddArticles: false,
        }

    }
    handleClose = () => {
        this.setState({ showAddArticles: false })
    }
    onChangeText = (key, val) => {
        const state = this.state;
        state[key] = val
        this.setState({ state })
    }
    _handleChangeSelect = (key, ...args) => {
        let _val = args[0];
        let val = _val[0];
        let option = _val[1];
        let data = val.map((item) => {
            return item.value
        })
        let state = this.state;
        state[key] = data;
        this.setState({
            state,
            [option.name]: val
        }, () => {

        });
    }
    getItems = (items) => {

        if (items && items.length > 0) {
            return items.map((item, index) => {
                let _item = {}
                return _item[`${item.label}`] = item.value
            })
        }
    }
    handleAdd = () => {
        let state = this.state;
        if (state.article != "") {
            let item = {
                article: state.article,
                descriptive_symbols: this.getItems(state.descriptive_symbols),
                exception_symbols: this.getItems(state.exception_symbols),
                location_symbols: this.getItems(state.location_symbols),
            }
            this.props.addNewItem(item);
            this.setState({ showAddArticles: false, ...initProps })
        }
    }
    getOptionsSelect = (key) => {
        let arr = SYMBOLS[key];
        const options = Object.keys(arr).map((key, index) => {
            return { 'label': arr[key], 'value': key }
        })
        return options
    }

    _renderModal = () => {
        return (
            <Modal show={this.state.showAddArticles} onHide={this.handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>New Articles</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Group controlId="Article">
                        <Form.Label>Article</Form.Label>
                        <Form.Control type="text"
                            placeholder="Enter Article"
                            onChange={(event) => this.onChangeText("article", event.target.value)}
                        />
                    </Form.Group>
                    <Form.Group controlId="descriptive_symbols">
                        <Form.Label> Descriptive Symbols</Form.Label>
                        <Select
                            name="descriptive_symbols"
                            options={this.getOptionsSelect("descriptive_symbols")}
                            value={this.state.descriptive_symbols}
                            onChange={(...args) => this._handleChangeSelect("descriptive_symbols", args)}
                            isMulti
                        />
                    </Form.Group>

                    <Form.Group controlId="exception_symbols">
                        <Form.Label> Exception Symbols</Form.Label>
                        <Select
                            name="exception_symbols"
                            options={this.getOptionsSelect("exception_symbols")}
                            value={this.state.exception_symbols}
                            onChange={(...args) => this._handleChangeSelect("exception_symbols", args)}
                            isMulti
                        />
                    </Form.Group>

                    <Form.Group controlId="location_symbols">
                        <Form.Label> Location Symbols</Form.Label>
                        <Select
                            name="location_symbols"
                            options={this.getOptionsSelect("location_symbols")}
                            value={this.state.location_symbols}
                            onChange={(...args) => this._handleChangeSelect("location_symbols", args)}
                            isMulti
                        />
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="success" onClick={this.handleAdd}>
                        Add
                 </Button>
                    <Button variant="secondary" onClick={this.handleClose}>
                        Close
                 </Button>

                </Modal.Footer>
            </Modal>
        )
    }
    render() {
        return (
            <Row className="p-2">
                <Button type={"button"} onClick={() => this.setState({ showAddArticles: true })}>
                    add
                </Button>
                {this._renderModal()}
            </Row>
        )
    }
}

export default AddNewArticles;